export const DB_FIELDS = [
  'area',
  'equipment_tag',
  'description',
  'zone',
  'category_epl',
  'system_component',
  'manufacturer',
  'model_no',
  'serial_no',
  'protection_class',
  'gas_group',
  'temperature_class',
  'ip_rating',
  'certifying_authority',
  'certificate_number',
  'work_order',
  'inspection_date',
  'inspection_type',
  'inspection_result',
  'inspector',
];

export const DB_FIELD_LABELS = {
  old_rfid: 'Existing RFID tag ID',
  area: 'Area',
  equipment_tag: 'Equipment tag',
  description: 'Description',
  zone: 'Zone',
  category_epl: 'Category / EPL',
  system_component: 'System / component',
  manufacturer: 'Manufacturer',
  model_no: 'Model number',
  serial_no: 'Serial number',
  protection_class: 'Protection class',
  gas_group: 'Gas group',
  temperature_class: 'Temperature class',
  ip_rating: 'IP rating',
  certifying_authority: 'Certifying authority',
  certificate_number: 'Certificate number',
  work_order: 'Work order',
  inspection_date: 'Inspection date',
  inspection_type: 'Inspection type',
  inspection_result: 'Inspection result',
  inspector: 'Inspector',
};

export const REQUIRED_DB_FIELDS = ['equipment_tag'];
export const getImportFields = (role) => role === 'admin' ? ['old_rfid', ...DB_FIELDS] : DB_FIELDS;
